import React from 'react';
import { keyframes, styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';

export const AddGadgetPanelSkeleton = () => (
	<GadgetSkeletonWrapper>
		<Skeleton height="40px" width="100%" />
		<Skeleton height="20px" width="100%" />
		<GadgetSkeletonItemWrapper>
			<Skeleton height="40px" width="40px" />
			<Skeleton height="40px" width="calc(100% - 60px)" />
		</GadgetSkeletonItemWrapper>
		<GadgetSkeletonItemWrapper>
			<Skeleton height="40px" width="40px" />
			<Skeleton height="40px" width="calc(100% - 60px)" />
		</GadgetSkeletonItemWrapper>
		<GadgetSkeletonItemWrapper>
			<Skeleton height="40px" width="40px" />
			<Skeleton height="40px" width="calc(100% - 60px)" />
		</GadgetSkeletonItemWrapper>
		<GadgetSkeletonItemWrapper>
			<Skeleton height="40px" width="40px" />
			<Skeleton height="40px" width="calc(100% - 60px)" />
		</GadgetSkeletonItemWrapper>
	</GadgetSkeletonWrapper>
);

const shimmer = keyframes({
	'0%': {
		backgroundPosition: '-300px 0',
	},
	'100%': {
		backgroundPosition: '1000px 0',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Skeleton = styled.div<{ height: string | number; width: string | number }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	height: ({ height }) => `${height}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	width: ({ width }) => `${width}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderRadius: `${gridSize / 2}px`,
	margin: `${token('space.200', '16px')} 0`,
	animationDuration: '1.2s',
	animationFillMode: 'forwards',
	animationIterationCount: 'infinite',
	animationName: shimmer,
	animationTimingFunction: 'linear',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('color.background.neutral', colors.N30),
	backgroundImage: `linear-gradient( to right, ${token(
		'color.background.neutral',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		colors.N30,
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	)} 10%, ${token('color.background.neutral', colors.N40)} 20%, ${token(
		'color.background.neutral',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		colors.N30,
	)} 30% )`,
	backgroundRepeat: 'no-repeat',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const GadgetSkeletonWrapper = styled.div({
	padding: token('space.200', '16px'),
	width: '100%',
	boxSizing: 'border-box',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const GadgetSkeletonItemWrapper = styled.div({
	display: 'flex',
	justifyContent: 'space-between',
});
